export const TermsGiftingContent = {
  pageTitle: `Before we can submit the gift request, we need you to sign and agree in the section below`,
  continueButton: `Submit`,
  errorMsg: `This field is required.`,
  vanguardGiftingAuthorizationStatement: `By clicking <b>I sign and agree</b> and <b>Submit</b> below, you authorize Vanguard Marketing Corporation and/or The Vanguard Group Inc., to transfer the identified assets as instructed in this application.`,
  nonVanguardGiftingAuthorization: `By clicking <b>I sign and agree</b> and <b>Submit</b> below, you authorize Vanguard Marketing Corporation to transfer the identified assets as instructed in this application to a third party, and you irrevocably relinquish all rights, title, and interest to those assets.`,
  signerTemplate: 'I, ${signer-name}, sign and agree',
  internal: {
    pageTitle: `Script to read to client`,
    giftingHeader: `Crew cannot submit on behalf of clients.`,
    giftingDescription: `Please nudge clients eligible for CXD Gifting off the call to self submit.`,
  },
};
